import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import Init from "./init";
import Auth from "./auth";
import Project from "./project";
import Province from "./province";
import Contact from "./contact";
import AccountReview from "./accountReview";
import Fund from "./fund";
import BankAccount from "./bankAccount";
import Bank from "./bank";
import Payment from "./payment";
import Receive from "./receive";
import Transfer from "./transfer";
import Activity from "./activity";
import ConstructionComponent from "./constructionComponent";
import DefaultConstructionComponent from "./defaultConstructionComponent";
import ConstructionComponentUnit from "./constructionComponentUint";
import ConstructionPhase from "./constructionPhase";
import DefaultConstructionPhase from "./defaultConstructionPhase";
import Tool from "./tool";
import Calendar from "./calendar";
import Cheque from "./cheque";
import WageRate from "./wageRate";
import ActivityWageRate from "./activityWageRate";
import Event from "./event";
import Dashboard from "./dashboard";
import { reducer as toastrReducer } from "react-redux-toastr";
import OverallCost from "./overallCost";
import OverallCostDetail from "./overallCostDetail";
import ChequeReview from "./chequeReview";
import Notification from "./notification";
import NotificationResponse from "./notificationResponse";
import BalanceSheet from "./balanceSheet";
import BalanceSheetDetail from "./balanceSheetDetail1";
import CostAndProfit from "./costAndProfit";
import PettyCash from "./pettyCash";
import ProjectSetting from "./projectSetting";
import File from "./file";
import DownloadFile from "./downloadFile";
import Feedback from "./feedback";
import Invitation from "./invitation";
import Premium from "./premium";
import CashFlow from "./cashFlow";
import Transaction from "./transaction";
import CountryCode from "./countryCode";
import Currencies from "./currencies";

export default history =>
  combineReducers({
    router: connectRouter(history),
    Init: Init,
    Auth: Auth,
    Project: Project,
    Province: Province,
    Contact: Contact,
    AccountReview: AccountReview,
    Fund: Fund,
    BankAccount: BankAccount,
    Bank: Bank,
    Activity: Activity,
    Payment: Payment,
    Receive: Receive,
    Transfer: Transfer,
    ConstructionComponent: ConstructionComponent,
    DefaultConstructionComponent: DefaultConstructionComponent,
    ConstructionComponentUnit: ConstructionComponentUnit,
    ConstructionPhase: ConstructionPhase,
    DefaultConstructionPhase: DefaultConstructionPhase,
    Tool: Tool,
    Calendar: Calendar,
    Cheque: Cheque,
    WageRate: WageRate,
    ActivityWageRate: ActivityWageRate,
    Event: Event,
    Dashboard: Dashboard,
    form: formReducer,
    toastr: toastrReducer,
    OverallCost: OverallCost,
    OverallCostDetail: OverallCostDetail,
    ChequeReview: ChequeReview,
    Notification: Notification,
    NotificationResponse: NotificationResponse,
    PettyCash: PettyCash,
    ProjectSetting: ProjectSetting,
    BalanceSheet: BalanceSheet,
    BalanceSheetDetail: BalanceSheetDetail,
    CostAndProfit: CostAndProfit,
    File: File,
    DownloadFile,
    Feedback: Feedback,
    Invitation: Invitation,
    Premium: Premium,
    CashFlow: CashFlow,
    Transaction: Transaction,
    CountryCode: CountryCode,
    Currencies: Currencies
  });
